module.exports = __webpack_public_path__ + "img/wrong.e2940cbe.svg";